import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Encabezado } from '../../Components/Encabezado/Encabezado';

import { 
  Autocomplete,
  Box,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from "@mui/material";

import Loading from "../../Components/Modals/Loading/Loader";

import { MdDeleteForever } from 'react-icons/md';
import { IoAddCircle } from 'react-icons/io5';

import swal from 'sweetalert';

import { 
  fetchCambiarSuccess,
  fetchListEmpleadoSinRestriccionComida, 
  fetchLockEmpleadosRestriccionComida, 
  selectEmpleados, 
  selectIsLoading,
  selectIsSuccess,
  selectMessage
} from '../../redux/Cafeteria/CafeteriaSlice';

import { selectUserData } from '../../redux/Login/LoginSlice';

import { BiSave } from 'react-icons/bi';

export const AgregarUsuariosRestriccion = () => {

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-SELECTOR
  const listEmpleados = useSelector(selectEmpleados);
  const isLoading = useSelector(selectIsLoading);
  const success = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);

  // ? HOOK-SELECTOR DE USUARIO ACTUALMENTE LOGUEADO.
  const { Id: usuarioId } = useSelector(selectUserData);

  // ? HOOK-STATE
  const [empleadosRestriccion, setEmpleadosRestriccion] = useState([]);
  const [empleadosRestriccionSave, setEmpleadosRestriccionSave] = useState([]);
  const [listEmpleadosState, setListEmpleadosState] = useState([]);

  // ? USE-STATE PARA LA PAGINACION
  const [ page, setPage ] = useState(0);
  const [ rowsPerPage, setRowsPerPage ] = useState(10);
  const [ skipRow, setSkipRow ] = useState(0);

  // * FUNCION PARA REFRESCAR LISTA.
  const refreshList = () => dispatch(fetchListEmpleadoSinRestriccionComida());

  // ? HOOK-EFFECT
  useEffect(() => {
    refreshList();
  }, [])

  // ? HOOK-EFFECT PARA SWEET-ALERT
  useEffect(() => {

    if (success === "success" && message.length > 0) {
      swal("Exitoso!", message, "success", {
          timer: 2000,
      });

      // * CAMBIAR SUCCESS A IDLE.
      dispatch(fetchCambiarSuccess());
      
      // * LIMPIAR LISTAS
      setEmpleadosRestriccion([]);
      setEmpleadosRestriccionSave([]);

      // * REFRESCAR TODAS LAS LISTAS NUEVAMENTE.
      refreshList();
    } 
    else if (success === "error") {
      swal("Error", message, "error", {
          timer: 4000
      });

      dispatch(fetchCambiarSuccess());
    }
  }, [success]);

  useEffect(() => {
    setListEmpleadosState(listEmpleados);
  }, [listEmpleados])

  // * FUNCIONES PARA PAGINACION.
  const handleChangePage = (event, newPage) => {
    setSkipRow(newPage * rowsPerPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setSkipRow(0);
  };

  // * FUNCION PARA AGREGAR USUARIOS AL LISTADOS
  const addEmpleadosListRestriccion = () => {

    if(empleadosRestriccion.length === 0){
      swal("Error", "Debe elegir uno o más empleados.", "error", {
        timer: 4000
      });
      return;
    }
    
    setEmpleadosRestriccionSave([...empleadosRestriccionSave, ...empleadosRestriccion]);
    
    // * FILTRADO DE EMPLEADOS QUE YA FUERON AGREGADOS A LA LISTA PARA EVITAR ERRORES DE DUPLICACION.
    const empleadosExist = listEmpleados.filter(x => !empleadosRestriccion.some(e => e.id === x.id)) ?? [];
    setListEmpleadosState(empleadosExist);

    // * LIMPIAR LA SELECCION DEL SELECT.
    setEmpleadosRestriccion([]);  
  }

  // * FUNCION PARA ELIMINAR A UN EMPLEADO DE LA LISTA DE USUARIOS BLOQUEADOS.
  const deleteEmpleadoRestriccion = (id) => {

    // * FILTRANDO Y ELIMINADO EL OBJETO QUE COINCIDE CON EL ID DEL EMPLEADO QUE SE VA A ELIMINAR PARA ACTUALIZAR LA LISTA ACTUAL;
    const empleadosFilterRestriccion = empleadosRestriccionSave.filter(x => x.id !== id);
    setEmpleadosRestriccionSave(empleadosFilterRestriccion);
    
    // * FILTRANDO LA LISTA DE EMPLEADOS DEL SELECT DE EMPLEADOS PARA ACTUALIZAR LA LISTA Y APAREZCA NUEVAMENTE EL USUARIO
    // * ELIMINADO DE LA LISTA DE RESTRICCION.
    setListEmpleadosState(listEmpleados.filter(x => !empleadosFilterRestriccion .some(e => e.id === x.id)) ?? [])
  }

  // * FUNCION PARA ENVIAR USUARIOS BLOQUEADOS A LA API.
  const saveData = () => {

    if(empleadosRestriccionSave.length === 0){
      swal("Error", "El listado está vacío, favor validar.", "error", {
        timer: 4000
      });
      return;
    }

    // * SELECCIONAR LOS IDS DE LOS EMPLEADOS QUE VAN A SER BLOQUEADOS
    const listUserIds = empleadosRestriccionSave.map(x => x.id);

    const data = {
      empleados: listUserIds,
      usuarioLogueado: usuarioId
    }

    // * MANDANDO DATA A LA API.
    dispatch(fetchLockEmpleadosRestriccionComida(data));
  }

  // ? Datos para la página actual (paginación).
  const empleadosPaginados = empleadosRestriccionSave.slice(skipRow, skipRow + rowsPerPage);

  return (
    <Encabezado title='Agregar restricción'>
      <Paper>
        <Box p={3} minHeight={'70pc'}>
          <Typography fontWeight='bold'>Empleados</Typography>
          <Autocomplete
            value={empleadosRestriccion}
            multiple
            id="tags-outlined"
            options={listEmpleadosState}
            getOptionLabel={(option) => option.nombreLabel}
            filterSelectedOptions
            onChange={(event, newValue) => {
              setEmpleadosRestriccion([
                ...newValue.filter((option) => listEmpleadosState.find(x => x.id === option.id))
              ]);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label=" "
                placeholder="Empleado"
              />
            )}
            className='mb-2'
          />

          <div className='d-flex justify-content-end'>
            <button onClick={() => addEmpleadosListRestriccion()} className='btn btn-primary-mem'>Agregar <IoAddCircle style={{marginBottom: 3}} fontSize='22' /></button>
          </div>

          <Box mt={2}>
            <Paper sx={{ width: '100%', mb: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{fontWeight: 'bold'}} width='50%'>
                      Empleado
                    </TableCell>
                    <TableCell sx={{fontWeight: 'bold'}} width='40%' align='center'>
                      Código
                    </TableCell>
                    <TableCell  align='right'>
                      
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    empleadosPaginados.length > 0 ?
                      empleadosPaginados.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            {item.nombres + " " + item.apellidos}
                          </TableCell>
                          <TableCell align='center'>
                            {item.codigoEmpleado}
                          </TableCell>
                          <TableCell>
                            <IconButton key={item.id}>
                              <MdDeleteForever color='red' onClick={() => deleteEmpleadoRestriccion(item.id)} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    :
                    <TableCell colSpan={3} align='center'>
                      <Typography>No hay registros</Typography>
                    </TableCell>
                  }
                </TableBody>
              </Table>
              <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={empleadosRestriccionSave.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Box>

          <div className='d-flex justify-content-end'>
            <button onClick={() => saveData()} className='btn btn-primary-mem'>Guardar  <BiSave style={{marginBottom: 3}} fontSize={22} /></button>
          </div>
            
        </Box>
      </Paper>

      <Loading open={isLoading} />

    </Encabezado>
  )
}
